import React from 'react';
import { useLanguage } from '../i18n/LanguageContext';
import { useInView } from '../hooks/useInView';
import '../styles/components/About.css';

function About() {
  const { t } = useLanguage();
  const [headingRef, headingInView] = useInView();
  const [contentRef, contentInView] = useInView();

  return (
    <section className="about" id="about">
      <div className="container">
        <h2 ref={headingRef} className={`reveal ${headingInView ? 'in-view' : ''}`}>{t.about.title}</h2>

        <div ref={contentRef} className={`about-content reveal reveal-delay ${contentInView ? 'in-view' : ''}`}>
          <p className="about-intro">
            {t.about.intro}
          </p>

          <div className="about-strengths">
            {t.about.strengths.map((item, index) => (
              <div className="strength-card" key={index}>
                <span className="strength-number">{String(index + 1).padStart(2, '0')}</span>
                <div className="strength-text">
                  <h3>{item.title}</h3>
                  <p>{item.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export default About;
